import { DisplayTrackers } from 'common/components/display-trackers';
import { TranslationsContextProvider } from 'common/hooks/translations-context-provider';
import { preloadBrowser, prepareFormat } from 'common/js/format-utils';
import 'common/scss/init.scss';
import * as React from 'react';
import { render } from 'react-dom';
import { DisplayConfigType, formatUnmarshaller } from './lib/config';
import { RootStore, StoreContext } from './lib/store';
import translations, {
  TranslationsKeys as TK,
  TranslationsType as TT
} from './lib/translations';
import { sendCustomTrack } from 'common/js/TrackAnalyticsHelper';
import { Display } from './views';
import { LoadingStrategyFactory } from './lib/loading-strategy/loading-strategy-factory';
import eventBus from 'common/event-handling/event-bus.model';
import { logMessage } from 'common/js/sentry';
import { PreloadErrorEvent } from 'common/event-handling/events';
import { DebugLog } from '../../common/js/debug-log';

window.initFormat = async options => {
  DebugLog.log('Display format init', options);
  const creativeSource: CreativeSource =
    options.context.creativeSource === 'redirect' ? 'redirect' : 'image';
  const formatName: FormatName = `Display ${creativeSource}`;
  let formatContext = await prepareFormat<TT, TK, DisplayConfigType>({
    formatName,
    formatUnmarshaller,
    options,
    translations
  });

  preloadBrowser(formatContext.config.browser);

  formatContext = LoadingStrategyFactory.getInstance().alterConfiguration(
    formatContext
  );

  const rootStore = new RootStore({
    formatName,
    formatContext,
    formatOptions: options
  });

  try {
    LoadingStrategyFactory.getInstance().onBeforeRender(formatContext);
  } catch (err) {
    logMessage(err as string);
    eventBus.publish(new PreloadErrorEvent());
    return;
  }

  sendCustomTrack('format_requested');

  let isRendered: boolean = false;

  render(
    <TranslationsContextProvider translate={formatContext.translate}>
      <StoreContext.Provider value={rootStore}>
        <Display />
        <DisplayTrackers {...formatContext.config.displayTrackers} />
      </StoreContext.Provider>
    </TranslationsContextProvider>,
    options.container,
    () => {
      if (isRendered) {
        return;
      }
      isRendered = true;
      LoadingStrategyFactory.getInstance().onAfterRender(formatContext);
    }
  );
};
